export default Object.freeze([
    {
        brand: 'AW EDH',
        url: 'https://familypetcare.s3-ap-southeast-2.amazonaws.com/TaggingGuides/Edenhills%20Albury%20Tagging%20Guide_June.pdf'
    },
    {
        brand: 'SA EDH',
        url: 'https://familypetcare.s3-ap-southeast-2.amazonaws.com/TaggingGuides/Edenhills%20SA%20Tagging%20Guide_June.pdf'
    },
    {
        brand: 'VIC EDH',
        url: 'https://familypetcare.s3-ap-southeast-2.amazonaws.com/TaggingGuides/Edenhills%20VIC%20Tagging%20Guide_June.pdf'
    },
    {
        brand: 'WA LWD',
        url: 'https://familypetcare.s3-ap-southeast-2.amazonaws.com/TaggingGuides/Lawnswood%20Tagging%20Guide_June.pdf'
    },
    {
        brand: 'NSW PaP-CW',
        url: 'https://familypetcare.s3.ap-southeast-2.amazonaws.com/TaggingGuides/NSW+P%26P-CW-tagging-guide.pdf'
    },
    {
        brand: 'NSW P&P-MO',
        url: 'https://familypetcare.s3.ap-southeast-2.amazonaws.com/TaggingGuides/NSW+P%26P-MO-tagging-guide.pdf'
    },
    {
        brand: 'QLD PiP',
        url: 'https://familypetcare.s3.ap-southeast-2.amazonaws.com/TaggingGuides/PiP-tagging-guide.pdf'
    },
    {
        brand: 'NSW P&P-SW',
        url: 'https://familypetcare.s3.ap-southeast-2.amazonaws.com/TaggingGuides/NSW+P%26P-SW-tagging-guide.pdf'
    },
]);
